define("calendar/components/calendar/bttp-promo", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Portal @destinationElement="root-portal">
    <Shared::Modal @closable={{true}} @close={{this.close}} @focusTrap={{true}} as |modal|>
      <modal.card class="o--modalCard--narrow">
        <modal.card-body>
          <div class="u--row u--row--noCollapse">
            <div class="u--col__6 u--p__t u--p__r">
              {{#if this.isTiktok}}
                <img class="o--media" src="/assets/images/img--bttp--promo__tiktok.png" />
              {{else}}
                <img class="o--media" src="/assets/images/img--bttp--promo__instagram.png" />
              {{/if}}
            </div>
            <div class="u--col__6">
              <modal.card-header class="u--p__t u--p__lr__0">
                <p class="o--modalHeader__title">
                  {{t (concat "bttp.discoverability." this.socialProfileType ".title")}}
                </p>
              </modal.card-header>
              <modal.card-body class="u--p__t__0 u--p__lr__0">
                <p>
                  {{html-safe (t (concat "bttp.discoverability." this.socialProfileType ".intro"))}}
                  <Shared::Link @href={{this.learnMoreLink}} @text={{t "shared_phrases.learn_more_lower_case"}} />
                </p>
                <ul class="u--listUnstyle">
                  <li class="u--m__b">
                    <span class="u--text--sm u--text--bold u--text--light">
                      {{t (concat "bttp.discoverability." this.socialProfileType ".step_1")}}
                    </span><br />
                    {{html-safe (t (concat "bttp.discoverability." this.socialProfileType ".step_1_description"))}}
                  </li>
                  <li class="u--m__b">
                    <span class="u--text--sm u--text--bold u--text--light">
                      {{t (concat "bttp.discoverability." this.socialProfileType ".step_2")}}
                    </span><br />
                    {{html-safe (t (concat "bttp.discoverability." this.socialProfileType ".step_2_description"))}}
                  </li>
                  <li>
                    <span class="u--text--sm u--text--bold u--text--light">
                      {{t (concat "bttp.discoverability." this.socialProfileType ".step_3")}}
                    </span><br />
                    {{t (concat "bttp.discoverability." this.socialProfileType ".step_3_description")}}
                  </li>
                </ul>
              </modal.card-body>
            </div>
          </div>
        </modal.card-body>
        <modal.card-footer>
          <Shared::Ui::Button
            @onClick={{this.close}}
            @text={{t "shared_phrases.not_now"}}
            @variant="outline"
            class="u--float--left"
          />
          <Shared::Ui::Button
            @onClick={{this.openCalendarSettings}}
            @text={{this.openCalendarSettingsText}}
            @variant="primary"
            class="u--float--right"
          />
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  </Shared::Portal>
  */
  {
    "id": "nHR6N338",
    "block": "[[[8,[39,0],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@closable\",\"@close\",\"@focusTrap\"],[true,[30,0,[\"close\"]],true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card\"]],[[24,0,\"o--modalCard--narrow\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__6 u--p__t u--p__r\"],[12],[1,\"\\n\"],[41,[30,0,[\"isTiktok\"]],[[[1,\"              \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--bttp--promo__tiktok.png\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--bttp--promo__instagram.png\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n            \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__t u--p__lr__0\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".title\"],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 u--p__lr__0\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[10,2],[12],[1,\"\\n                \"],[1,[28,[35,5],[[28,[37,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".intro\"],null]],null]],null]],[1,\"\\n                \"],[8,[39,6],null,[[\"@href\",\"@text\"],[[30,0,[\"learnMoreLink\"]],[28,[37,3],[\"shared_phrases.learn_more_lower_case\"],null]]],null],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n                \"],[10,\"li\"],[14,0,\"u--m__b\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"u--text--sm u--text--bold u--text--light\"],[12],[1,\"\\n                    \"],[1,[28,[35,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_1\"],null]],null]],[1,\"\\n                  \"],[13],[10,\"br\"],[12],[13],[1,\"\\n                  \"],[1,[28,[35,5],[[28,[37,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_1_description\"],null]],null]],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"li\"],[14,0,\"u--m__b\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"u--text--sm u--text--bold u--text--light\"],[12],[1,\"\\n                    \"],[1,[28,[35,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_2\"],null]],null]],[1,\"\\n                  \"],[13],[10,\"br\"],[12],[13],[1,\"\\n                  \"],[1,[28,[35,5],[[28,[37,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_2_description\"],null]],null]],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"li\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"u--text--sm u--text--bold u--text--light\"],[12],[1,\"\\n                    \"],[1,[28,[35,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_3\"],null]],null]],[1,\"\\n                  \"],[13],[10,\"br\"],[12],[13],[1,\"\\n                  \"],[1,[28,[35,3],[[28,[37,4],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_3_description\"],null]],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,7],[[24,0,\"u--float--left\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"close\"]],[28,[37,3],[\"shared_phrases.not_now\"],null],\"outline\"]],null],[1,\"\\n        \"],[8,[39,7],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"openCalendarSettings\"]],[30,0,[\"openCalendarSettingsText\"]],\"primary\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]]]]]],[\"modal\"],false,[\"shared/portal\",\"shared/modal\",\"if\",\"t\",\"concat\",\"html-safe\",\"shared/link\",\"shared/ui/button\"]]",
    "moduleName": "calendar/components/calendar/bttp-promo.hbs",
    "isStrictMode": false
  });
  let BttpPromoComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class BttpPromoComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "bttp", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      this.bttp?.seenBttpDiscovery();
    }
    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }
    get isTiktok() {
      return Boolean(this.socialProfile?.isTiktok);
    }
    get socialProfileType() {
      return this.socialProfile?.profileType;
    }
    get openCalendarSettingsText() {
      if (this.bttp.canBttp) {
        return this.intl.t('bttp.discoverability.enable_in_calendar');
      }
      return this.intl.t('bttp.discoverability.upgrade_in_calendar');
    }
    get learnMoreLink() {
      return this.bttp.learnMoreLink;
    }
    openCalendarSettings() {
      this.args.close();
      this.args.viewCalendarSettings();
      this.segment.track('bttp-opt-in', {
        social_profile_handle: this.socialProfile?.nickname || '',
        active_trial: !!this.subscriptions.hasActiveTrial
      });
    }
    close() {
      this.args.close();
      this.segment.track('declined-bttp', {
        social_profile_handle: this.socialProfile?.nickname || '',
        active_trial: !!this.subscriptions.hasActiveTrial
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openCalendarSettings", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openCalendarSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BttpPromoComponent);
});